// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","registrationButtonSubtitle":"_1fl7eu2SmGcOHBo1HQgBhj"};